import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterSattahip extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <div><Link to='/'>Home</Link></div>
      <h3>Member's Names</h3>
      <br />
      <br />

        <div><Link to='/conduct-teerayutp'>1. AAT 2471  CAPT.TEERAYUT PAKDEEPAK(Dojocho)(A)</Link></div>
        <br />
        <div><Link to='/conduct-billyz'>2. AAT 5170  MR.BILLY ZAENGLEIN(A)</Link></div>
        <br />
        <div><Link to='/conduct-wacharapongs'>3. AAT 0467  RADM.WACHARAPONG SASITHORN(A)</Link></div>
        <br />
        <div><Link to='/conduct-tanapolp'>4. AAT 0840  RADM.TANAPOL PITAYAPAT(A)</Link></div>
        <br />
        <div><Link to='/conduct-rattapongp'>5. AAT 4478  LT.RATTAPONG PONGSUWAN(A)</Link></div>
        <br />
        <div><Link to='/conduct-nitchakarnt'>6. AAT 7759  CPO1.NITCHAKARN THAWORNKAN(A)</Link></div>
        <br />
        <div><Link to='/conduct-sanphets'>7. AAT 7761  CPO1.SANPHET SUKPRATHUEANG(A)</Link></div>
        <br />
        <div><Link to='/conduct-kanokphonc'>8. AAT 7779  MS.KANOKPHON CHAIYAWONG(A)</Link></div>
        <br />
        <div><Link to='/conduct-metapornc'>9. AAT 7833  MS.METAPORN CHIM-IM(A)</Link></div>
        <br />
        <div><Link to='/conduct-ratchadapornn'>10. AAT 7817  MS.RATCHADAPORN NONNUSAT(A)</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>11. AAT  7910  MR.NAPOL PITAYAPAT(A)</Link></div>
        <br />
        <div><Link to='/conduct-autp'>12. AAT 7745  CDR.AUT PANGPASSA(A)</Link></div>
        <br />
        <div><Link to='/conduct-supachais'>13. AAT 7832  CPO1.SUPACHAI SITTIRUK(A)</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>14. AAT 7923  MR.THOMAS MOENKEMEIER(A)</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>15. AAT 7925  LT.ASDAWUT CHODSAPTHAWEE(A)</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>16. AAT 7972  CPO1.SUNYA LAEID(A)</Link></div>
        <br />
        <div><Link to='/conduct-yaranyapohnk'>17. AAT 7747  MS.VARANYAPOHN KASSANUKA(A)</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>18. AAT 7783  LT.NIRUN CHANTAWARO(A)</Link></div>
        <br />
        <div><Link to='/conduct-yanint'>19. AAT 7822  MS.YANIN TAIYANON(A)</Link></div>
        <br />
        <div><Link to='/conduct-angieo'>20. AAT 7884  MS.ANGELICA JOSELINE OLSSON(A)</Link></div>
        <br />
        <div><Link to='/conduct-sreytiah'>21. AAT  7892  MS.SREYTIA HEBBLETHWAITE(A)</Link></div>
        <br />
        <div><Link to='/conduct-nueas'>22. AAT 8006  MS.NUEA SUDRAK(A)</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>23. AAT 8027  MS.BARBARA BARZARKINA(A)</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>24. AAT 8029  MS.PANYASUPHA KHEMARUT(A)</Link></div>
        <br />
        <div><Link to='/conduct-marceld'>25. AAT 8024  MR.MARCEL DEKE(A)</Link></div>
        <br />
        <div><Link to='/conduct-kanyaphatp'>26. AAT 8026  MS.KANYAPHAT PRIYACHANASAKUL(A)</Link></div>
        <br />
        <div><Link to='/conduct-nannaphatp'>27. AAT 8028  MS.NANNAPHAT PRIYACHANASAKUL(A)</Link></div>
        <br />
        <div><Link to='/conduct-zaidena'>28. AAT 8044  MR.ZAIDEN ANDERSSON(A)</Link></div>
        <br />
        <div><Link to='/conduct-benjaminb'>29. AAT 8045  MR.BENJAMIN BROWN(A)</Link></div>
        <br />
        <div><Link to='/conduct-tylerb'>30. AAT 8046  MR.TYLER BROWN(A)</Link></div>
        <br />
        <div><Link to='/conduct-wyonab'>31. AAT 8047  MS.WYONA BROWN(A)</Link></div>
        <br />
        <div><Link to='/conduct-thongchomphunutr'>32. AAT  7887  MS.THONGCHOMPHUNUT ROJVIBOONCHAI(A)</Link></div>
        <br />
        <div><Link to='/conduct-tarah'>33. AAT  7891  MS.TARA HEBBLETHWAITE(A)</Link></div>
        <br />
        <div><Link to='/conduct-uraveet'>34. AAT  7896  MS.URAVEE THEPWIMOLPETCHKUL(A)</Link></div>
        <br />
        <div><Link to='/conduct-janicej'>35. AAT  7897  MS.JANICE JAMES(A)</Link></div>
        <br />
        <div><Link to='/conduct-natsawittau'>36. AAT  7908  MS.NATSAWITTA UNGPRAPAKORN(A)</Link></div>
        <br />
        <div><Link to='/conduct-panupats'>37. AAT 7924  LT.PANUPAT SANSOOK(A)</Link></div>
        <br />
        <div><Link to='/conduct-pongworakornp'>38. AAT 7962  MR.PONGWORAKORN PAOJEEN(A)</Link></div>
        <br />
        <div><Link to='/conduct-andrewl'>39. AAT 7973  MR.ANDREW LINDQVIST(A)</Link></div>
        <br />
        <div><Link to='/conduct-jamesrh'>40. AAT 8003  MR.JAMES RICKY HEBBLETHWAITE(A)</Link></div>
        <br />
        <div><Link to='/conduct-natthapony'>41. AAT 8004  MR.NATTHAPON YATAN(A)</Link></div>
        <br />
        <div><Link to='/conduct-naruekarink'>42. AAT 8036  MR.NARUEKARIN KHEMARUT(A)</Link></div>
        <br />
        <div><Link to='/conduct-kansinees'>43. AAT 8048  MS.KANSINEE SAIMONTREE(A)</Link></div>
        <br />
        <div><Link to='/conduct-narns'>44. AAT 8049  MS.NARN SUDRAK(A)</Link></div>
        <br />
        <div><Link to='/conduct-jaiklal'>45. AAT 8067  MR.JAIKLA LORGUNPAI(A)</Link></div>
        <br />
        <div><Link to='/conduct-panyaphatk'>46. AAT 7961  MR.PANYAPHAT KONGSEANG(A)</Link></div>
        <br />
        <div><Link to='/conduct-crystalmd'>47. AAT 8005  MS.CRYSTAL MARIE DABI(A)</Link></div>
        <br />
        <div><Link to='/conduct-watcharapongb'>48. AAT 8025  LT.WATCHARAPONG BUMRUNGKLANG(A)</Link></div>
        <br />
        <div><Link to='/conduct-kank'>49. AAT 8030  MR.KAN KAIWANNON(A)</Link></div>
        <br />
        <div><Link to='/conduct-natdanaid'>50. AAT 8031  MR.NATDANAI DOUNGRATSAMEE(A)</Link></div>
        <br />
        <div><Link to='/conduct-athichonmf'>51. AAT 8032  MR.ATHICHONM FUANGKAEW(A)</Link></div>
        <br />
        <div><Link to='/conduct-carinad'>52. AAT 8037  MS.CARINA DEKE(A)</Link></div>
        <br />
        <div><Link to='/conduct-pittayac'>53. AAT 8077  MR.PITTAYA CHAMNANPOOD(A)</Link></div>
        <br />
        <div><Link to='/conduct-pordeer'>54. AAT 8078  MS.PORDEE RATTANARAK(A)</Link></div>
        <br />
        <div><Link to='/conduct-pemikar'>55. AAT 8079  MS.PEMIKA RATTANA(A)</Link></div>
        <br />
        <div><Link to='/conduct-pattarapony'>56. AAT 8080  MR.PATTARAPON YOUNGHAIPON(A)</Link></div>
        <br />
        <div><Link to='/conduct-piyanats'>57. AAT 8081  MR.PIYANAT SUPATTHANAKORNKIT(A)</Link></div>
        <br />
        <div><Link to='/conduct-ratchaninp'>58. AAT 8082  MS.RATCHANIN PEEPANICH(A)</Link></div>
        <br />
        <div><Link to='/conduct-natnateep'>59. AAT 8083  MR.NATNATEE PEEPANICH(A)</Link></div>
        <br />
        <div><Link to='/conduct-bowwonlukc'>60. AAT 8084  MS.BOWWONLUK CHAMNANPOOD(A)</Link></div>
        <br />
        <div><Link to='/conduct-ratcharatp'>61. AAT 7746  MS.RATCHARAT PANGPASSA(A)</Link></div>
        <br />
        <div><Link to='/conduct-pattapongc'>62. AAT 7760  PO.PATTAPONG CHOKPRADITSUK(A)</Link></div>
        <br />
        <div><Link to='/conduct-lulladaa'>63. AAT 7773  MS.LULLADA ANANTAPAN(A)</Link></div>
        <br />
        <div><Link to='/conduct-chayanind'>64. AAT 7831  MS.CHAYANIN DUANGPROM(A)</Link></div>
        <br />
        <div><Link to='/conduct-supapimpisap'>65. AAT 7863  MS.SUPAPIMPISA PISETSILP(A)</Link></div>
        <br />
        <div><Link to='/conduct-anandat'>66. AAT 7895  MR.ANANDA TATARINOV(A)</Link></div>
        <br />





        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterSattahip;
